import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import { useLocation } from '@reach/router'; // eslint-disable-line import/no-unresolved
import MiniCards from './MiniCards';
import RequestDemo from './RequestDemo';
import CustomTitle from './CustomTitle';

Hero.propTypes = {
  hero: PropTypes.object,
  wrapperClassName: PropTypes.string,
};

// const heroSliderProps = {
//   dots: false,
//   arrows: false,
//   infinite: true,
//   fade: true,
//   autoplay: true,
//   autoplaySpeed: 3000,
//   speed: 2000,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   rows: 1,
//   responsive: [
//     {
//       breakpoint: 990,
//       settings: {
//         slidesToShow: 1,
//       },
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//       },
//     },
//   ],
// };
// const odysseyImages = [
//   { src: '/img/odysseyRedesignCard.png', alt: 'algo Marketplace' },
//   // { src: '/img/strategy-details-records.png', alt: 'strategy details records' },
// ];
const pythonSliderProps = {
  dots: false,
  arrows: false,
  infinite: true,
  fade: true,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 2000,
  slidesToShow: 1,
  slidesToScroll: 1,
  rows: 1,
  responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

export default function Hero({ hero, wrapperClassName }) {
  const location = useLocation();
  return (
    <section className="build-hero-container">
      <div className="build-hero-wrapper">
        <div className="build-hero-left">
          <div
            className={hero?.miniCards ? 'hero-with-cards' : 'hero-no-cards'}>
            {hero.displayTitle && (
              <div className="displayTitle">{hero.displayTitle}</div>
            )}
            <h1>
              {location.pathname === '/' ? (
                <CustomTitle hero={hero} />
              ) : (
                hero.title
              )}
            </h1>
            <p>{hero?.description}</p>
          </div>
          {hero?.miniCards && <MiniCards minicards={hero?.miniCards} />}
          <div
            className={`build-hero-btns ${hero?.primary?.extraButton ? 'extra-button-class' : ''}`}>
            {hero?.primary?.redirect && (
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="button"
                href={hero?.primary?.redirect}>
                {hero?.primary?.label}
                <svg
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="arrow-right"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true">
                  <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z"></path>
                </svg>
              </a>
            )}

            {hero?.primary?.extraButton && (
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="button"
                href={hero?.primary?.extraButton.link}>
                {hero?.primary?.extraButton.label}
                <svg
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="arrow-right"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true">
                  <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z"></path>
                </svg>
              </a>
            )}
            {hero?.primary?.formType && <RequestDemo data={hero.primary} />}

            {hero?.secondary?.redirect && (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={hero?.secondary?.redirect}
                className="button button-border">
                {hero?.secondary?.label}
              </a>
            )}
            {hero?.secondary?.formType && (
              <RequestDemo data={hero.secondary} noBackground />
            )}
            {hero?.text?.formType && (
              <RequestDemo data={hero.text} type="text" omitSvg />
            )}
          </div>
        </div>
        {hero.videoURL && (
          <div
            className={`hero-build-hero-slider-container ${wrapperClassName}`}>
            <div className="iframe-video">
              <iframe
                title={
                  hero.displayName
                    ? `Video - ${hero.displayName}`
                    : 'Video Player'
                }
                height="100%"
                width="100%"
                src={hero.videoURL}
                frameBorder="0"
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                allowfullscreen="true"></iframe>
            </div>
          </div>
        )}
        {hero.slideImages && (
          <div
            className={`hero-build-hero-slider-container ${wrapperClassName}`}>
            <div className="col">
              <div className="image-block image-drop-shadow">
                <Slider {...pythonSliderProps}>
                  {hero.slideImages.map((img) => (
                    <img
                      key={img.alt}
                      src={img.src}
                      alt={img.alt}
                      className="slide-img"
                    />
                  ))}
                </Slider>
              </div>
            </div>
            {/* {hero.images?.length < 1 ? (
            <Slider {...heroSliderProps}>
              {hero.images.map((img) => (
                <img key={img.alt} src={img.src} alt={img.alt} />
              ))}
            </Slider>
          ) : (
            <img
              src={hero.images?.[0].src}
              style={{ maxWidth: 'unset' }}
              alt={hero.images?.[0]?.alt}
            />
          )} */}
          </div>
        )}
      </div>
    </section>
  );
}
